import { render, staticRenderFns } from "./ResellerFeatureLists.vue?vue&type=template&id=bc285750&"
import script from "./ResellerFeatureLists.vue?vue&type=script&lang=js&"
export * from "./ResellerFeatureLists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bc285750')) {
      api.createRecord('bc285750', component.options)
    } else {
      api.reload('bc285750', component.options)
    }
    module.hot.accept("./ResellerFeatureLists.vue?vue&type=template&id=bc285750&", function () {
      api.rerender('bc285750', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Services/Hosting/Reseller/ResellerFeatureLists.vue"
export default component.exports